<div class="option-label">
  <ng-container
    *ngTemplateOutlet="optionLabelTemplate() ?? optionLabelDefaultTemplate.template; context: { $implicit: option() }"
  />
</div>

@if (option().count !== undefined) {
  <div class="option-count">
    {{ option().count | number }}
  </div>
}

<ng-template
  #optionLabelDefaultTemplate="mpTypedTemplate"
  mpTypedTemplate
  [contextType]="optionLabelTemplateContextType"
  let-option
>
  @if (option.icon) {
    <mat-icon class="option-label__icon material-icons-outlined" [mpIcon]="option.icon" />
  }

  <div class="option-label__text truncate" [title]="option.label">
    {{ option.label }}
  </div>
</ng-template>
